import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { StatCards } from "components/statCards";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useRepassesSetoriaisState } from "./context/repasses-setoriais-context";
import { useRepassesSetoriaisController } from "./context/repasses-setoriais-controller";
import { RepassesSetoriaisTable } from "./repassesSetoriaisTable.component";

const formatCurrency = (value?: number) =>
  (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export function RepassesSetoriaisPage() {
  const { repasses, repassePagedRequest, loading, areas, origens, ultimaAtualizacao, totais, error } = useRepassesSetoriaisState();
  const { onInit, handleOnChange, listRepasses, exportRepasses } = useRepassesSetoriaisController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listRepasses({ ...repassePagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Repasses Setoriais" },
        ]}
      />
      <PageTitle>Repasses Setoriais</PageTitle>
      <Wrapper>
        <StatCards
          items={[
            { label: "Valor Total Previsto", value: formatCurrency(totais?.valorTotalPrevisto), variant: 'green' },
            { label: "Valor Total Realizado", value: formatCurrency(totais?.valorTotalRealizado), variant: 'blue' },
          ]}
        />
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Descrição"
                  value={repassePagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-ano"
                  label="Exercício"
                  value={repassePagedRequest?.ano || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Área</InputLabel>
                  <Select
                    name="select-area-id"
                    value={repassePagedRequest?.idAreaTransparenciaSetorial || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Área"
                    displayEmpty
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {areas?.map((a) => (
                      <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Origem</InputLabel>
                  <Select
                    name="select-origem-id"
                    value={repassePagedRequest?.idOrigemRepasseSetorial || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Origem"
                    displayEmpty
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {origens?.map((o) => (
                      <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SearchButton onClick={() => (async () => {
                  await listRepasses(repassePagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={repassePagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportRepasses} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <RepassesSetoriaisTable currentItems={repasses} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={repasses?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
